module.exports = __webpack_public_path__ + "static/GrayGminaOsiek-289948211aabb2623dc10736ffda38ec.svg";